// Auto-generated per-query builders for Constraint
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ConstraintReadAPI, ConstraintWriteAPI, ConstraintReadAPISchema, ConstraintWriteAPISchema } from '../types/constraint';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ConstraintHasChildConstraints, Formalises, HasAttribute, HasAttributeValue, HasDerivedValue, Mentions } from '../../relationships/relationship';

import { RFLPElement } from './rflpelement';
import { Requirement } from './requirement';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';





// Builder chain for query: rflp-constraint-by-id

export interface RflpConstraintByIdBuilder_0 {
  get(id: string): RflpConstraintByIdBuilder_1;
  filter(conditions: { id: string }): RflpConstraintByIdBuilder_1;
}

export interface RflpConstraintByIdBuilder_1 {
  all(): Promise<Constraint[]>;
  first(): Promise<Constraint | null>;
  get(): Promise<Constraint[]>;
  execute(): Promise<Constraint[]>;
}


// Union of all query entry points
export type ConstraintQueryBuilder = RflpConstraintByIdBuilder_0;

// Available query names for .setQuery()
export type ConstraintQueryNames = "rflp-constraint-by-id";

// Type narrowing for .setQuery()
export type ConstraintBuilderForQuery<Q extends ConstraintQueryNames> =
  Q extends "rflp-constraint-by-id" ? RflpConstraintByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ConstraintInstanceQueryResult<Q extends ConstraintQueryNames> =
  Q extends "rflp-constraint-by-id" ? RflpConstraintByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-constraint-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ConstraintQueryNames>(queryName: Q): ConstraintBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Constraint extends Partial<ConstraintReadAPI> {}
export class Constraint extends NeoNodeBase<ConstraintReadAPI, ConstraintWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Constraint";
  static readonly readSchema = ConstraintReadAPISchema;
  static readonly writeSchema = ConstraintWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    mentions: { target: "RFLPElement", cardinality: "many", isParent: false, relClass: "Mentions", direction: "out" },
    formalises: { target: "Requirement", cardinality: "many", isParent: true, relClass: "Formalises", direction: "out" },
    parent_constraint: { target: "Constraint", cardinality: "one", isParent: true, relClass: "ConstraintHasChildConstraints", direction: "in" },
    child_constraints: { target: "Constraint", cardinality: "many", isParent: false, relClass: "ConstraintHasChildConstraints", direction: "out" },
  };

  protected get modelName(): string {
    return 'Constraint';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Constraint.label;
  }


  constructor(data: Partial<ConstraintWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ConstraintReadAPI, loadContext?: Record<string, any>): Constraint {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { mentions, formalises, parent_constraint, child_constraints, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ConstraintReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, mentions: mentions, formalises: formalises, parent_constraint: parent_constraint, child_constraints: child_constraints, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Constraint.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'mentions', 'RFLPElement', ModelRegistry);
    loadManyRelationship(processed, 'formalises', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'parent_constraint', 'Constraint', ModelRegistry);
    loadManyRelationship(processed, 'child_constraints', 'Constraint', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Constraint(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ConstraintQueryBuilder {
    return new QueryBuilderImpl('Constraint').filter(conditions) as any;
  }

  static all(): ConstraintQueryBuilder {
    return new QueryBuilderImpl('Constraint') as any;
  }

  static async first(): Promise<Constraint | null> {
    const results = await new QueryBuilderImpl('Constraint').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ConstraintQueryNames>(queryName: Q): ConstraintBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Constraint');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ConstraintQueryNames>(queryName: Q): ConstraintInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Constraint.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'child_constraints' - Python ORM style (cached)
  get child_constraints(): RelationshipManager<this, Constraint> {
    return this.getOrCreateRelationshipManager('child_constraints', () => {
      return new RelationshipManager(this, 'child_constraints', 'many', ConstraintHasChildConstraints as typeof Relationship);
    });
  }

  // Relationship manager for 'mentions' - Python ORM style (cached)
  get mentions(): RelationshipManager<this, RFLPElement> {
    return this.getOrCreateRelationshipManager('mentions', () => {
      return new RelationshipManager(this, 'mentions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'formalises' - Python ORM style (cached)
  get formalises(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('formalises', () => {
      return new RelationshipManager(this, 'formalises', 'many', Formalises as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_constraint' - Python ORM style (cached)
  get parent_constraint(): RelationshipManager<this, Constraint> {
    return this.getOrCreateRelationshipManager('parent_constraint', () => {
      return new RelationshipManager(this, 'parent_constraint', 'one', ConstraintHasChildConstraints as typeof Relationship);
    });
  }

}
